import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Box,
  Typography,
  Paper,
  Button,
  useTheme,
  Divider,
  CircularProgress,
} from "@mui/material";
import InboxIcon from "@mui/icons-material/Inbox";
import axios from "axios";

const TransactionWidget = () => {
  const theme = useTheme();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  // inside TransactionWidget:
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("https://fentrixbank.org/api/api/transactions", { withCredentials: true })
      .then((res) => {
        // 👇 Laravel paginator wraps results in `data`
        setTransactions(res.data.data || []);
      })
      .catch((err) => {
        console.error("Error fetching transactions:", err);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 3,
        p: { xs: 2, md: 3 },
        mt: { xs: 1, md: 0 },
        mb: { xs: 4, md: 6 },
        width: "112%", // ✅ Responsive full width
        maxHeight: 500,
        overflowY: "auto",
        backgroundColor: theme.palette.mode === "dark" ? "#1e293b" : "#fff",
      }}
    >
      {/* Title Row */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="subtitle1" fontWeight="bold">
          Recent Transactions
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "#3b82f6",
            fontWeight: 500,
            cursor: "pointer",
            "&:hover": { textDecoration: "underline" },
          }} 
          onClick={() => navigate("/transactions")} 
        >
          View all
        </Typography>
      </Box>

      <Divider sx={{ mb: 2 }} />

      {/* Show loader / empty state / transactions */}
      {loading ? (
        <Box sx={{ textAlign: "center", py: 3 }}>
          <CircularProgress size={24} />
        </Box>
      ) : transactions.length === 0 ? (
        <Box sx={{ textAlign: "center", py: 4 }}>
          <InboxIcon sx={{ fontSize: 60, color: "text.disabled", mb: 1 }} />
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            No transactions yet
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={2}>
            Your transaction history will appear here
          </Typography>
          <Button
            variant="contained"
            fullWidth
            sx={{
              color: "#fff",
              backgroundColor: "#3b82f6",
              textTransform: "none",
              borderRadius: 2,
              py: 1,
              "&:hover": { backgroundColor: "#2563eb" },
            }}
            onClick={() => navigate("/deposits")} 
          >
            + Make your first deposit
          </Button>
        </Box>
      ) : (
        transactions.map((tx) => (
          <Box
            key={tx.id}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              pb: 1,
              borderBottom: "1px solid",
              borderColor: theme.palette.mode === "dark" ? "grey.800" : "grey.200",
            }}
          >
            <Box>
              <Typography variant="body2" fontWeight="bold">
                {tx.beneficiary_name}
              </Typography>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: { xs: "0.7rem", md: "0.75rem" } }}
              >
                {tx.type} • {new Date(tx.created_at).toLocaleDateString()}
              </Typography>
            </Box>
            <Typography
              variant="body2"
              fontWeight="bold"
              sx={{
                color: tx.status === "pending" ? "orange" : "green",
                fontSize: { xs: "0.85rem", md: "0.9rem" },
              }}
            >
              - ${Number(tx.amount).toLocaleString()}
            </Typography>
          </Box>
        ))
      )}
    </Paper>
  );
};

export default TransactionWidget;